import { Theme } from "@emotion/react";
import styled from "@emotion/styled";
import { useMantineColorScheme } from "@mantine/core";

interface DetailWrapperProps {
  children: React.ReactNode;
}

export const DetailWrapper = ({ children }: DetailWrapperProps) => {
  const { colorScheme } = useMantineColorScheme();
  return <Wrapper theme={{ colorScheme }}>{children}</Wrapper>;
};

const Wrapper = styled.div<{ theme: Theme & { colorScheme: "dark" | "light" } }>`
  padding: 8px;
  background-color: ${({ theme }) =>
    theme.colorScheme === "dark" ? "var(--gray-9, #1e1e1e)" : "var(--gray-2, #f8f9fa)"};
`;
